if (document.getElementById('user-coats')) {
  let placeholderCoats = document.getElementById('prod-info').getAttribute('prod-coats')
  document.getElementById('user-coats').setAttribute('value', placeholderCoats)
}
var found = ''

function toggleCalculatorEpoxy() {
  const wrap = $('#area-calculator__wrap');
  const isOpening = !wrap.is(':visible');
  const overlay = document.getElementById("calculator-drawer-overlay");
  const drawer = document.getElementById("epoxy-calculator-drawer");

  if (!isOpening) {
    wrap.stop().slideUp(500, function () {
      $(this).fadeOut(500);
    });

    if (overlay && drawer) {
      document.body.classList.remove("body-scroll-lock");
      drawer.style.right = "-100%";
      overlay.style.backgroundColor = "transparent";
      setTimeout(() => {
        overlay.style.display = "none";
        drawer.style.display = "none";
      }, 500);
    }
  } else {
    if (overlay && drawer) {
      document.body.classList.add("body-scroll-lock");
      overlay.style.display = "block";
      drawer.style.display = "flex";
      setTimeout(() => {
        drawer.style.transition = "right 0.2s ease-in-out";
        drawer.style.right = "0";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 500);
    }

    wrap.stop().fadeIn(500, function () {
      $(this).slideDown(500);
    });

    const description = document.getElementById('area-calculator-description');
    if (description && !description.classList.contains('mobile-description__display')) {
      description.classList.add('mobile-description__display');
      $('#area-calculator-description').show();
    }

    $('#button-main').show();
    $('#option-size').show();
    $("[for='option-size']").show();
    $('#quantity-selector').show();
    $('.quantity-label').show();
    $('.quantity-wrapper').show();
  }
}


function toggleCalculatorMobileEpoxy() {
  var now = new Date().getTime()
  var day = 1000 * 60 * 60 * 24
  var closeTimeOut = 5 * (60 * 60 * 1000)

  $('#area-calculator__wrap').toggleClass('show')
  $('#button-main').toggle()
  $('#option-size').toggle()
  $("[for='option-size']").toggle()
  $('#quantity-selector').toggle()
  $('.quantity-label').toggle()
  $('.quantity-wrapper').toggle()
  $('#area-calculator-description').toggleClass('mobile-description__display')

  if (now - localStorage.getItem('date') >= closeTimeOut) {
    localStorage.setItem('calculatorDescription', '0')
  }
  if (localStorage.calculatorDescription != '1') {
    $('#area-calculator-description').css('display', 'block')
    $('.mobile-description__close').css('display', 'block')
    localStorage.setItem('calculatorDescription', '0')
  }
}

function toggleCalculator() {
  console.log('toggleCalculator fired');
  document.querySelectorAll('.calc-btn__arrow').forEach(arrow => {
    arrow.classList.toggle('rotate180');
  });

  const isVolumeMode = document.getElementById('prod-info').getAttribute('volume') == true;

  if (isVolumeMode) {
    console.log('toggleCalculator running first block');
    $('#calculator__wrap').toggleClass('show');
    $('#calculator__wrap').toggle('fade');
    $('#button-main').toggle();
    $('#option-size').toggle();
    $("[for='option-size']").toggle();
    $('#quantity-selector').toggle();
    $('.quantity-label').toggle();
    $('.quantity-wrapper').toggle();
  } else {
    console.log('toggleCalculator running');

    const overlay = document.getElementById("calculator-drawer-overlay");
    const drawer = document.getElementById("calculator-drawer");
    const wrap = $('#area-calculator__wrap');
    const isOpening = !wrap.is(':visible');

    if (overlay && drawer) {
      if (!isOpening) {
        document.body.classList.remove("body-scroll-lock");
        drawer.style.right = "-100%";
        overlay.style.backgroundColor = "transparent";
        setTimeout(() => {
          overlay.style.display = "none";
          drawer.style.display = "none";
        }, 500);
      } else {
        document.body.classList.add("body-scroll-lock");
        overlay.style.display = "block";
        drawer.style.display = "flex";
        drawer.style.transition = "right 0.2s ease-in-out";
        setTimeout(() => {
          drawer.style.right = "0";
          overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        }, 500);
      }
    }

    if (isOpening) {
      const description = document.getElementById('calculator-description');
      if (description && !description.classList.contains('mobile-description__display')) {
        description.classList.add('mobile-description__display');
        $('#calculator-description').show();
      }
    }

    wrap.toggleClass('show');
    $('#button-main').toggle();
    $('#option-size').toggle();
    $("[for='option-size']").toggle();
    $('#quantity-selector').toggle();
    $('.quantity-label').toggle();
    $('.quantity-wrapper').toggle();
  }
}



function toggleCalculatorDescription() {
  let description = document.getElementById('calculator-description')
  if (description.classList.contains('mobile-description__display')) {
    $('#calculator__wrap').toggleClass('show')
    $('#calculator__wrap').toggle('fade')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('#calculator-description').toggleClass('mobile-description__display')
  } else {
    $('#calculator__wrap').toggleClass('show')
    $('#calculator__wrap').toggle('fade')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()

    var left = $('#calculator-description').css('left')
    if ($('#calculator-description').attr('show') == 'no') {
      $('#calculator-description').attr('show', 'yes')
      setTimeout(function () {
        $('#calculator-description').toggle('fade')
        $('#calculator-description').animate(
          {
            left: '-=100%',
            right: '0%',
          },
          500,
        )
      }, 500)
    } else {
      $('#calculator-description').toggle('fade')
      $('#calculator-description').attr('show', 'no')
      setTimeout(function () {
        $('#calculator-description').css('left', '0px')
      }, 500)
    }
  }
}
function toggleCalculatorMobile() {
  const wrap = $('#area-calculator__wrap');
  if (wrap.is(':visible')) {
    wrap.fadeOut(500);
  } else {
    wrap.fadeIn(500);
  }
  if (document.getElementById('prod-info').getAttribute('volume') == '') {
    $('#volume-calculator__wrap').toggleClass('show')
    $('#volume-calculator__wrap').toggle('fade')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()
  } else {
    $('#area-calculator__wrap').toggleClass('show')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()
  }
}

function toggleCalculatorMobileDescription() {
  var now = new Date().getTime()
  var day = 1000 * 60 * 60 * 24
  var closeTimeOut = 5 * (60 * 60 * 1000)

  $('#calculator__wrap').toggleClass('show')
  $('#calculator__wrap').toggle('fade')
  $('#button-main').toggle()
  $('#option-size').toggle()
  $("[for='option-size']").toggle()
  $('#quantity-selector').toggle()
  $('.quantity-label').toggle()
  $('.quantity-wrapper').toggle()
  $('#calculator-description').toggleClass('mobile-description__display')

  if (now - localStorage.getItem('date') >= closeTimeOut) {
    localStorage.setItem('calculatorDescription', '0')
  }
  if (localStorage.calculatorDescription != '1') {
    $('#area-calculator-description').css('display', 'block')
    $('.mobile-description__close').css('display', 'block')
    localStorage.setItem('calculatorDescription', '0')
  }
}
function toggleMobileDescription() {
  if (localStorage.calculatorDescription != '1') {
    var date = new Date().getTime()
    localStorage.calculatorDescription = '1'
    localStorage.setItem('date', date)
  }
  $('#area-calculator-description').toggle()
  $('.mobile-description__close').toggle()
}

function removeRecommended() {
  document.getElementById('recommended-coats').style.display = 'none'
}
function areaCheck(that) {
  if (that.value == 'no') {
    $('#width-length').fadeIn(500)
    document.getElementById('width-length').style.display = 'flex'
    $('#area-input').prop('disabled', true)
    // $('#area-input').fadeOut(500);
  } else {
    $('#width-length').fadeOut(500)
    $('#area-input').prop('disabled', false)
    // $('#area-input').fadeIn(500);
  }
}

function areaCalculate() {
  var width = +document.getElementById('width').value
  var height = +document.getElementById('length').value
  var area = width * height
  document.getElementById('area-input').value = area
}

function calculateAreaPaint() {
  const userArea = +document.getElementById('area-input').value
  const userCoats = +document.getElementById('user-coats').value
  const floatLabels = document.querySelectorAll('.calculator__float-label, .calculator__float-label-multi')

  const prod2 = document.getElementById('2-item')
  const prod5 = document.getElementById('5-item')

  const totalArea = userArea * userCoats

  document.getElementById('prod-result-2-5').value = ''
  document.getElementById('prod-result-5').value = ''
  document.getElementById('prod-result').value = ''

  document.getElementById('multi-size-results').style.display = 'none'
  document.getElementById('single-result').style.display = 'none'

  if (prod2 && prod5) {
    document.getElementById('multi-size-results').style.display = 'flex'
    const prodArea2 = +prod2.querySelector('.prod-info').getAttribute('prod-area')
    const prodArea5 = +prod5.querySelector('.prod-info').getAttribute('prod-area')
    const prodCoats = document.querySelector('#prod-info').getAttribute('prod-coats')

    const needed2 = totalArea / prodArea2
    const needed5 = totalArea / prodArea5

    let qty2 = 0
    let qty5 = 0

    if (needed2 <= 1) {
      qty2 = Math.ceil(needed2)
    } else if ((Math.ceil(needed2)) >= 2 && ((Math.ceil(needed2)) % 2 != 0)) {
      qty2 = 1
      qty5 = Math.floor(needed5)
    } else if (needed2 > 1) {
      qty5 = Math.ceil(needed5)
    }

    document.getElementById('prod-result-2-5').value = qty2
    document.getElementById('prod-result-5').value = qty5

  } else {
    // Single-size fallback
    document.getElementById('single-result').style.display = 'block'
    const prodArea = +document.getElementById('prod-info').getAttribute('prod-area')
    const result = Math.ceil((userArea * userCoats) / prodArea)
    document.getElementById('prod-result').value = result
  }

  for (let i = 0; i < floatLabels.length; i++) {
    floatLabels[i].style.display = 'block'
  }
}

function calculateAreaEpoxy() {
  const userArea = +document.getElementById('area-input').value
  const prodCoats = 2
  const floatLabels = document.querySelectorAll('.calculator__float-label, .calculator__float-label-multi')

  const prod2 = document.getElementById('2-item')
  const prod5 = document.getElementById('5-item')

  const prodArea2 = +prod2.querySelector('.prod-info').getAttribute('prod-area')
  const prodArea5 = +prod5.querySelector('.prod-info').getAttribute('prod-area')

  let qty2 = 0
  let qty5 = 0

  const needed2 = userArea / prodArea2
  const needed5 = userArea / prodArea5

  if (needed2 <= 1) {
    qty2 = Math.ceil(needed2)
  } else if ((Math.ceil(needed2) >= 2) && (Math.ceil(needed2) % 2 !== 0)) {
    qty2 = 1
    qty5 = Math.floor(needed5)
  } else if (needed2 > 1) {
    qty5 = Math.ceil(needed5)
  }

  const totalQty2 = qty2 * prodCoats
  const totalQty5 = qty5 * prodCoats

  document.getElementById('2.5-result').value = totalQty2
  document.getElementById('5-result').value = totalQty5

  for (let i = 0; i < floatLabels.length; i++) {
    floatLabels[i].style.display = 'block'
  }
}

function calculatorSubmit(e) {
  let itemOne = $('#2-item__quantity').attr('variant')
  let qtyOne = $('#2-item__quantity').val()
  let itemTwo = $('#5-item__quantity').attr('variant')
  let qtyTwo = $('#5-item__quantity').val()
  jQuery
    .getJSON('/cart.js', function (data) {
      console.log(data)
    })
    .done(function (data) {
      let dataItems = data.items
      console.log(dataItems)

      for (var i = 0; i < dataItems.length; i++) {
        if (dataItems[i].id == itemOne) {
          console.log('item one basket :' + dataItems[i].quantity)
          qtyOne = +dataItems[i].quantity + +qtyOne
          console.log('updated item one:' + qtyOne)
        } else if (dataItems[i].id == itemTwo) {
          console.log('item two basket :' + dataItems[i].quantity)
          qtyTwo = +dataItems[i].quantity + +qtyTwo
          console.log('updated item one:' + qtyTwo)
        }
      }
    })
    .always(function (data) {
      console.log(itemOne)
      console.log(itemTwo)
      console.log(qtyOne)
      console.log(qtyTwo)
      jQuery.post('/cart/update.js', {
        updates: {
          [itemOne]: qtyOne,
          [itemTwo]: qtyTwo,
        },
      })
      setTimeout(function () {
        $(location).attr('href', '/cart')
      }, 100)
    })
}
/* Close logic for drawers */
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("calculator-drawer-overlay");
  const drawers = [
    document.getElementById("calculator-drawer"),
    document.getElementById("epoxy-calculator-drawer")
  ];
  const closeButtons = document.querySelectorAll(".drawer__close");

  closeButtons.forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      drawers.forEach(function (drawer) {
        if (drawer && drawer.style.display === "flex") {
          drawer.style.transition = "right 0.2s ease-in-out";
          drawer.style.right = "-100%";
        }
      });
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0)";
      setTimeout(() => {
        drawers.forEach(function (drawer) {
          if (drawer) drawer.style.display = "none";
        });
        overlay.style.display = "none";
        document.body.classList.remove("body-scroll-lock");

        const areaDesc = document.getElementById('area-calculator-description');
        if (areaDesc && areaDesc.classList.contains('mobile-description__display')) {
          areaDesc.classList.remove('mobile-description__display');
          $('#area-calculator-description').hide();
        }

        const calcDesc = document.getElementById('calculator-description');
        if (calcDesc && calcDesc.classList.contains('mobile-description__display')) {
          calcDesc.classList.remove('mobile-description__display');
          $('#calculator-description').hide();
        }
      }, 200);

    });
  });
  if (overlay) {
    overlay.addEventListener("click", function () {
      drawers.forEach(function (drawer) {
        if (drawer && drawer.style.display === "flex") {
          drawer.style.transition = "right 0.2s ease-in-out";
          drawer.style.right = "-100%";
        }
      });
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0)";
      setTimeout(() => {
        drawers.forEach(function (drawer) {
          if (drawer) drawer.style.display = "none";
        });
        overlay.style.display = "none";
        document.body.classList.remove("body-scroll-lock");

        const areaDesc = document.getElementById('area-calculator-description');
        if (areaDesc && areaDesc.classList.contains('mobile-description__display')) {
          areaDesc.classList.remove('mobile-description__display');
          $('#area-calculator-description').hide();
        }

        const calcDesc = document.getElementById('calculator-description');
        if (calcDesc && calcDesc.classList.contains('mobile-description__display')) {
          calcDesc.classList.remove('mobile-description__display');
          $('#calculator-description').hide();
        }
      }, 200);

    });
  }
});